<template>
  <div style="height: 100%;">
    <div>
      <Header />
      <div class="main-wrapper plolicy-top-box width9440 service-box">
            <div class="search-box">
                <select>
                  <option>北京</option>
                  <option>上海</option>
                  <option>深圳</option>
                </select>
                <div class="search-input-box">
                    <input type="type" placeholder="请输入搜索内容" name="">
                    <button>搜索</button>
                </div>
            </div>

            <div class="policy-main">
                <div class="policy-top-tab">
                    <!-- tab nav -->
                    <ViewTabList />
                    <!-- tab nav -->
                    <!-- 筛查条件pc -->
                    <div class="screening-box">
                        <div class="screen-items">
                            <p>分类：</p>
                            <div class="right-text">
                              <a href="javascript:;" class="active">咨询规划</a>
                              <a href="javascript:;">专业设计</a>
                              <a href="javascript:;">工程建设</a>
                              <a href="javascript:;">人力外包</a>
                              <a href="javascript:;">监理审计</a>
                              <a href="javascript:;">创新场景</a>
                              <a href="javascript:;">金融服务</a>
                              <a href="javascript:;">其他</a>
                            </div>
                        </div>
                        <div class="screen-items">
                            <p>领域：</p>
                            <div class="right-text">
                              <a href="javascript:;" class="active">新基建</a>
                              <a href="javascript:;">数字云上</a>
                              <a href="javascript:;">智慧城市</a>
                              <a href="javascript:;">其他</a>
                            </div>
                        </div>
                    </div>
                    <!-- 筛查条件pc -->
                    <!-- 筛查条件-移动端 -->
                    <div class="m-screening-box">
                      <select>
                        <option>政策级别</option>
                        <option>政策级别</option>
                      </select>
                      <select>
                        <option>专业职称</option>
                        <option>专业职称</option>
                      </select>
                    </div>
                    <!-- 筛查条件-移动端 -->
                </div>

                <!-- 政策列表 -->
                <div class="policy-list policy-list-service">
                    <div @click="publishProject" class="consulting">发 布 需 求</div>
                    <ul>
                      <li class="policy-li">
                        <div class="left-txt">
                              <div class="img1">
                                 <img  src="../assets/main/img1.png">
                              </div>
                              <div class="service-title">
                                <h3>政务解决方案</h3>
                                <p class="pp1">面向区级、镇街、村社三级的单位和个人，整合人力社保、食药安全、文化教育、民政婚育、就业租房等办事服务系统，提供全主题覆盖的两百余项办事服务。</p>
                                <p class="pp2">发布时间：2020-06-21</p>
                                <div class="btn-box">
                                    <a href="javascript:;">新基建</a>
                                    <a href="javascript:;">咨询规划</a>
                                </div>
                              </div>
                        </div>
                        <div class="talent-plan">
                            <a href="javascript:;">北京通州</a>
                        </div>
                      </li>
                    </ul>
                </div>
                <!-- 政策列表 -->
            </div>

      </div>
      <Footer :isLogin="true" />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import ViewTabList from '@/components/ViewTabList.vue';

export default {
    name: 'Project',
    components: {
        Header,
        Footer,
        ViewTabList
    },
    watch: {
        $route(to, from) {}
    },
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
      publishProject() {
        this.$router.push('project-publish?type=project');
      },
      queryProject(){
        
      },
    }
}
</script>

<style scoped>
  @import url(./Policy.css);
  @import url(./service.css);
</style>
